<template>
    <div class="container">
        <div class="handle-box-search">
            <el-row class="head-search">
                <el-col :span="12">
                    <span class="title">乘客电话:</span>

                    <el-input
                        v-model="search_data.scan_consumer_phone"
                        placeholder="请输入乘客电话"
                        maxlength="11"
                        class="handle-input mr10"
                        @keyup.enter.native="driverDanLists"
                    ></el-input>
                </el-col>

                <el-col :span="12" style="margin-top: 10px">
                    <span class="title">扫码时间:</span>

                    <el-date-picker
                        v-model="search_time"
                        type="datetimerange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        @change="timeChange"
                        style="width: 350px"
                    >
                    </el-date-picker>
                </el-col>
            </el-row>
            <el-row class="head-search">
                <el-col :span="12">
                    <span class="title">司机电话:</span>

                    <el-input
                        v-model="search_data.driver_phone"
                        placeholder="请输入司机电话"
                        maxlength="11"
                        class="handle-input mr10"
                        @keyup.enter.native="driverDanLists"
                    ></el-input>
                </el-col>

                <el-col :span="12" style="margin-top: 10px">
                    <span class="title">订单编码:</span>

                    <el-input
                        style="width: 350px"
                        v-model="search_data.order_code"
                        placeholder="请输入订单编码"
                        class="handle-input mr10"
                        @keyup.enter.native="driverDanLists"
                    ></el-input>
                </el-col>
            </el-row>
            <el-row class="head-search">
                <el-col :span="12">
                    <span class="title">是否下单:</span>

                    <el-select v-model="search_data.place_order" placeholder="请选择状态" clearable @keyup.enter.native="driverDanLists">
                        <el-option label="是" value="1"> </el-option>
                        <el-option label="否" value="0"> </el-option>
                    </el-select>
                </el-col>
            </el-row>

            <el-button type="primary" icon="el-icon-search" @click="searchdriverDanLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button :icon="progress_show ? 'el-icon-loading' : 'el-icon-setting'" @click="toExport" :disabled="progress_show"
                >{{ progress_show ? '导出中...' : '导出' }}
            </el-button>
        </div>

        <!-- 表格 -->
        <el-table
            :data="tableData"
            style="width: 100%"
            ref="multipleTable"
            header-cell-class-name="table-header"
            @selection-change="handleSelectionChange"
        >
            <el-table-column prop="consumer_name" label="乘客姓名"> </el-table-column>

            <el-table-column prop="consumer_phone" label="乘客电话"> </el-table-column>

            <el-table-column prop="name" label="司机姓名"> </el-table-column>
            <el-table-column prop="driver_phone" label="司机电话"> </el-table-column>

            <el-table-column prop="order_code" label="订单编码"> </el-table-column>

            <el-table-column prop="place_order.alias" label="是否下单"> </el-table-column>

            <el-table-column prop="money" label="奖励金额"> </el-table-column>

            <el-table-column prop="driver_commitment_money" label="司机承担金额"> </el-table-column>

            <el-table-column prop="company_commitment_moeny" label="公司承担金额"> </el-table-column>

            <el-table-column prop="time.YmdHis" label="扫码时间"> </el-table-column>
            <el-table-column prop="pay_time_stamp" label="交易成功时间"> </el-table-column>
            <el-table-column prop="order_time_stamp" label="下单时间"> </el-table-column>

            <!--            <el-table-column label="操作">-->
            <!--                <template slot-scope="scope">-->

            <!--                    <el-dropdown split-button type="primary"-->
            <!--                                 @click="edit_isShow = !edit_isShow; edit_data = scope.row.driver_dan_set_code; " trigger="click">-->

            <!--                        编辑-->

            <!--                        <el-dropdown-menu slot="dropdown">-->

            <!--                            <el-dropdown-item @click.native="del(scope.row.driver_dan_set_code)">删除段位</el-dropdown-item>-->

            <!--                        </el-dropdown-menu>-->

            <!--                    </el-dropdown>-->

            <!--                </template>-->
            <!--            </el-table-column>-->
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 添加组件 -->
        <!--        <addDriverDan :isShow="add_isShow" @onSubmit="driverDanLists"></addDriverDan>-->

        <!-- 编辑组件 -->
        <!--        <editDriverDan :isShow="edit_isShow" :data="edit_data" @onSubmit="driverDanLists"></editDriverDan>-->
    </div>
</template>

<script>
// import addDriverDan from './addDriverDan.vue';
// import editDriverDan from './editDriverDan.vue';
var _this;
export default {
    components: {
        // addDriverDan,
        // editDriverDan
    },

    data() {
        return {
            add_isShow: false,

            edit_isShow: false,
            edit_data: '',

            progress_show: false,

            search_time: '',

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10,
                order_code: '',
                driver_phone: '',
                scan_consumer_phone: '',
                fixed_array: '',
                place_order: ''
            },
            excelData: [],

            excelHead: [],
            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.driverDanLists();
    },

    methods: {
        toExport() {
            _this.search_data.page = 1;
            _this.getExcelData();
        },

        getExcelData() {
            _this
                .$post('/driver/driverScancodeLists', _this.search_data)
                .then((res) => {
                    _this.progress_show = true;

                    if (this.$route.path == '/driverScancodeLists') {
             
                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.length; i++) {
                            _this.excelData.push({
                                consumer_name: res.data[i].consumer_name,
                                consumer_phone: res.data[i].consumer_phone,
                                driver_name: res.data[i].name,
                                driver_phone: res.data[i].driver_phone,
                                order_code: res.data[i].order_code,
                                level_set: res.data[i].place_order.alias,
                                money: res.data[i].money,
                                driver_commitment_money: res.data[i].driver_commitment_money,
                                company_commitment_moeny: res.data[i].company_commitment_moeny,
                                time: res.data[i].time.YmdHis,
                                order_time: res.data[i].order_time_stamp,
                                pay_time: res.data[i].pay_time_stamp
                            });
                        }


                        if (_this.search_data.page * _this.search_data.limit < res.count) {
                            _this.search_data.page = _this.search_data.page + 1;

                            // _this.progress_data = Math.floor((res.data.page * res.data.limit / res.data.count) * 100);

                            _this.getExcelData();
                        } else {
                  

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                        }
                    } else {
                        _this.progress_show = false;
                    }
                })
                .catch((err) => {});
        },

        // 导出excel方法
        exportData() {
            const { export_json_to_excel } = require('@/vendor/Export2Excel');
            const tHeader = [
                '乘客姓名',
                '乘客电话',
                '司机姓名',
                '司机电话',
                '订单编码',
                '是否下单',
                '奖励金额',
                '司机承担金额',
                '公司承担金额',
                '扫码时间',
                '下单时间',
                '交易成功时间'
            ];
            const filterVal = [
                'consumer_name',
                'consumer_phone',
                'driver_name',
                'driver_phone',
                'order_code',
                'level_set',
                'money',
                'driver_commitment_money',
                'company_commitment_moeny',
                'time',
                'order_time',
                'pay_time'
            ];
            const list = this.excelData;
            const data = this.formatJson(filterVal, list);
            export_json_to_excel(tHeader, data, 'fileName');
        },

        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },

        del(code) {
            _this
                .$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/driver/delDriverDanSetSubmit', {
                            driver_dan_set_code: code
                        })
                        .then((res) => {
                            _this.$message.success(res.msg);
                            _this.driverDanLists();
                        })
                        .catch((err) => {});
                })
                .catch(() => {
                    _this.$message({
                        message: '已取消删除',
                        duration: 1500
                    });
                });
        },

        cityChange(val) {
            _this.search_data.city_code = val;
            if (val != '') {
                _this
                    .$post('/city/getCityDetails', {
                        city_code: val
                    })
                    .then((res) => {
                        _this.company_name = res.data.company.name;
                    })
                    .catch((err) => {});
            } else {
                _this.company_name = '';
            }
        },

        //搜索的下拉框弹出触发
        cityVisibleChange(val) {
            if (val && _this.options_city_code.length < 1) {
                // 请求公司管理接口获取公司唯一编码
                _this
                    .$post('/city/cityLists', _this.city_options_data)
                    .then((res) => {
                        _this.options_city_code = res.data;
                    })
                    .catch((err) => {});
            }
        },

        searchdriverDanLists() {
            _this.search_data.page = 1;
            _this.driverDanLists();
        },

        timeChange(val) {
            if (val !== null) {
                _this.search_data.fixed_array = JSON.stringify(['between'].concat(val));
            } else {
                _this.search_data.fixed_array = '';
            }
        },
        // 搜索司机日志列表
        driverDanLists() {
            _this
                .$post('/driver/driverScancodeLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.driverDanLists();
        },

        handleSelectionChange(val) {
            var datalist = [];

            for (var i in val) {
                datalist.push(val[i].driver_code);
            }
            _this.delDriverSubmit_data.driver_code_array = datalist;
        },
        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-form-item.el-form-item--small {
    width: 100%;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
}

.el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
}
</style>
